import {
  inventory_target_overall_v4,
  inventory_target_cluster_v4,
  inventory_target_area_v4,
  inventory_target_branch_v4,
} from "../../v4-services/reports/inventory_target_service";
import { actionTypes } from "../action_types";

const defaultData = { monthlyTargetSummaries: [] };

const createInventoryTargetAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data !== null ? resp.data : defaultData,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetInventoryTargetOverallV4 = createInventoryTargetAction(
  inventory_target_overall_v4,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_OVERALL
);

export const GetInventoryTargetClusterV4 = createInventoryTargetAction(
  inventory_target_cluster_v4,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_CLUSTER
);

export const GetInventoryTargetAreaV4 = createInventoryTargetAction(
  inventory_target_area_v4,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_AREA
);

export const GetInventoryTargetBranchV4 = createInventoryTargetAction(
  inventory_target_branch_v4,
  actionTypes.REPORTS_INVENTORY_TARGET_GET_BRANCH
);
